import { useQuery } from '@tanstack/react-query';
import { AppSettingsService } from '../AppSettingsService';

export const useAppSettings = () =>
  useQuery({
    queryKey: ['app-settings'],
    queryFn: () => AppSettingsService.listAppSettings(),
  });
